export default __webpack_public_path__ + "static/media/POFY.7525b358.JPG";